<template>
    <template-layout>
        <template slot="header">
            <h1 class="title">Productos</h1>
        </template>

        <template slot="content">
            <section class="container">
                <div class="columns">
                    <div class="sidebar column is-one-quarter">
                        <product-categories v-bind:categories="categories" v-bind:selected-category="selectedCategory" v-on:category-changed="onCategoryChanged"></product-categories>
                    </div>
                    <div class="column">
                        <product-listing v-bind:products="products" v-on:product-selected="onProductSelected"></product-listing>

                        <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
                    </div>
                </div>
            </section>

            <product-detail-modal ref="product-modal"></product-detail-modal>
        </template>
    </template-layout>
</template>

<script>
    import TemplateLayout from '../../layout/TemplateLayout.vue';
    import ProductCategories from './ProductCategories.vue';
    import ProductListing from './ProductListing.vue';
    import ProductDetailModal from '../../components/product/ProductDetailModal.vue';

    export default {
        name: 'products',
        data() {
            return {
                defaultCategory: 13,
                selectedCategory: null,
                products: [],
                categories: [],
                isLoading: false
            }
        },
        components: {
            TemplateLayout,
            ProductCategories,
            ProductListing,
            ProductDetailModal
        },
        mounted() {
            this.$api.getCategories().then(response => {
                this.categories = response ? response : [];
            }).then(() => {
                this.loadCategoryById(this.$route.params.id ? parseInt(this.$route.params.id) : this.defaultCategory);
            });
        },
        watch: {
            '$route'(to, /*from*/) {
                this.loadCategoryById(to.params.id ? parseInt(to.params.id) : this.defaultCategory);
            },

            selectedCategory(category) {
                this.isLoading = true;

                this.$api.getProducts(category.id).then(response => {
                    this.products = response;
                    this.isLoading = false;
                });
            }
        },
        methods: {
            onCategoryChanged(category) {
                // on category change just navigate to the new one
                this.$router.push({name: 'Products', params: {id: category.id}}).catch(err => {});
            },

            onProductSelected(product) {
                let modal = this.$refs['product-modal'];

                modal.show(product);
            },

            loadCategoryById(id) {
                for(let i = 0; i < this.categories.length; ++i) {
                    if(this.categories[i].id === id) {
                        this.selectedCategory = this.categories[i];
                        break;
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    div.content h1 {
        text-align: left;
        font-weight: normal;
    }

    div.sidebar h2 {
        font-size: 1.0em;
        text-align: left;
        margin: 0px 0px 20px;
        padding: 0px;
    }

    div.sidebar h2:before {
        content: "";
        position: absolute;
        left: 0;
        top: 40px;
        height: 1px;
        width: 40px;
        border-bottom: 2px solid $highlight-color;
    }

    .subtitle {
        padding-bottom: 1.0em;
        border-bottom: 1px solid #e6e5e5;
    }

</style>